import React, { Fragment, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import * as Yup from "yup";
import swal from "sweetalert";
import CustomInput from "../../../Custom/CustomInput";
import { Field, FormikProvider, useFormik } from "formik";
import { Alert, Col, Form, InputGroup, Label, Row } from "reactstrap";
import CustomSelect from "../../../Custom/CustomSelect";
import CustomFlatpickr from "../../../Custom/CustomFlatpicker";
import { Modal } from "react-bootstrap";
import CustomPhoneInput from "../../../Custom/CustomPhoneInput";
import { get, post } from "../../../Helper/api_helper";
import ModalOrderBookingDetail from "../../../Custom/ModalOrderBookingDetail";
import { Spin } from "antd";
import { t } from "i18next";
import moment from "moment";

import {
  POST_GetModeOfPaymentDDL,
  POST_AdminOrderBookingAdvancesSearchByOrderBookingNo,
  POST_AdminOrderBookingAdvancesInsert,
  POST_AdminOrderBookingAdvancesDetailByID,
} from "../../../Helper/url_helper";

const AddOrderBookingAdvance = () => {
  const history = useHistory();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [isLoading, setIsLoading] = useState(false);
  const [orderDetailModal, setOrderDetailModal] = useState(false);
  const [modeOfPaymentOptions, setModeOfPaymentOptions] = useState([]);
  const [orderBookingID, setOrderBookingID] = useState("");

  const [orderBookingNo, setOrderBookingNo] = useState("");
  const [country, setCountry] = useState("");
  const [countryCode, setCountryCode] = useState("");

  const validationSchema = Yup.object().shape({
    OrderBookingNo: Yup.string()
      .nullable()
      .required("Order Booking No is required field"),
    AdvanceAmount: Yup.number()
      .nullable()
      .min(1, "Advance Amount is required field")
      .required("Advance Amount is required field"),

    AdvanceReceivedDate: Yup.string()
      .nullable()
      .required("Advance Received Date is required field"),
    ModeofPayment: Yup.string()
      .nullable()
      .required("Mode of Payment is required field"),
    AdvanceGivenByName: Yup.string()
      .nullable()
      .required("Advance Given By Name is required field"),
    MobileNo: Yup.string().nullable().required("Mobile No is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CompanyID: AuthUser?.CompanyIDEncrypt,
      AddOrderBookingID: "",
      OrderBookingNo: "",
      AdvanceAmount: "",
      AdvanceReceivedDate: "",
      ModeofPayment: "",
      AdvanceRemark: "",
      AdvanceGivenByName: "",
      MobileNo: "",
      PatientName: "",
      PatientNo: "",
      ClientName: "",
      OrderBookingDate: "",
      TotalAdvanceAmount: "",
      CountryCode: "+91",
    },
    validateOnBlur: false,
  });

  const {
    setValues,
    setFieldValue,
    values: {
      CompanyID,
      AddOrderBookingID,
      OrderBookingNo,
      AdvanceAmount,
      AdvanceReceivedDate,
      ModeofPayment,
      AdvanceRemark,
      AdvanceGivenByName,
      MobileNo,
      PatientName,
      PatientNo,
      ClientName,
      OrderBookingDate,
      TotalAdvanceAmount,
      CountryCode,
    },
  } = formik;

  useEffect(() => {
    loadModeOfPaymentOptionsDDL();
  }, []);

  const getOrderDetailsByOrderBookingNo = async () => {
    if (OrderBookingNo) {
      //alert(OrderBookingNo);
      //alert(CompanyID);
      setIsLoading(true);
      await post(POST_AdminOrderBookingAdvancesSearchByOrderBookingNo, {
        OrderBookingNo: OrderBookingNo,
        CompanyID: CompanyID,
      }).then((res) => {
        if (res.IsSuccess) {
          // alert(AddOrderBookingID);
          //alert(res.OrderBookingIDEncrypt);
          setValues({
            OrderBookingNo: OrderBookingNo,
            AddOrderBookingID: res.OrderBookingIDEncrypt,
            PatientName: res.PatientName,
            PatientNo: res.PatientNo,
            ClientName: res.ClientName,
            OrderBookingDate: res.OrderBookingDate,
            TotalAdvanceAmount: res.TotalAdvanceAmount,
            CompanyID: CompanyID,
            AdvanceAmount: res.AdvanceAmount,
            AdvanceReceivedDate: "",
            ModeofPayment: "",
            AdvanceRemark: "",
            AdvanceGivenByName: "",
            MobileNo: "",
            CountryCode: "+91",
          });
        } else {
          swal({
            // title: "warning",
            text: "Order Booking No. not found....!",
            icon: "warning",
            button: "OK",
          });
          formik.resetForm();
          formik.setFieldValue("OrderBookingNo", OrderBookingNo);
          formik.setFieldValue("CompanyID", CompanyID);
        }
      });
      setIsLoading(false);
    } else {
      // OrderBookingNo: Yup.string()
      // .nullable()
      // .required("Order Booking No is required field"),
      swal({
        //title: "warning",
        text: "Order Booking No. is required field",
        icon: "warning",
        button: "OK",
      });
      return;
    }
  };

  const loadModeOfPaymentOptionsDDL = async () => {
    await post(POST_GetModeOfPaymentDDL)
      .then((res) => {
        if (res.IsSuccess) {
          setModeOfPaymentOptions(
            res.ModeOfPaymentList.map((item) => ({
              label: item.ModeOfPayment,
              value: item.ModeOfPaymentID,
            }))
          );
        }
      })
      .catch((error) => console.log(error));
  };

  const handleValidSubmit = (values, { setSubmitting }) => {
    if (AddOrderBookingID === "") {
      swal({
        //title: "warning",
        text: "Order Booking No. is Invalid...!",
        icon: "warning",
        button: "OK",
      });
      return;
    }
    setIsLoading(true);

    const data = {
      AdvanceAmount: values.AdvanceAmount.toString(),
      AdvanceReceivedDate: `${moment(values.AdvanceReceivedDate)
        .format("YYYY-MM-DD")
        .replace(/^\-/, "")} 00:00:00.000`,
      AdvanceRemarks: values.AdvanceRemark,
      AdvanceGivenByName: values.AdvanceGivenByName,
      MobileNo: values.MobileNo,
      OrderBookingIDEncrypt: values.AddOrderBookingID,
      ModeOfPaymentID: values.ModeofPayment,
      CreatedByEncrypt: AuthUser.LoginIDEncrypt,
      CountryCode: "+" + values.CountryCode.replace(/\+/g, ""),
    };

    post(POST_AdminOrderBookingAdvancesInsert, data)
      .then((response) => {
        if (response.IsSuccess) {
          swal({
            title: "Success",
            text: t(response.MessageCode),
            icon: "success",
            button: "OK",
          });
          history.push("/order-booking-advance");
        } else {
          swal({
            title: "Error",
            text: t(response.MessageCode),
            icon: "error",
            button: "OK",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setIsLoading(false);
  };

  //const { handleValidSubmit, isSubmitting } = formik;

  return (
    <>
      <Fragment>
        <Spin size="large" spinning={isLoading} tip={"Loading..."}>
          <PageTitle
            activeMenu="Add Advance Receipt"
            motherMenu={
              <Link to="/order-booking-advance">Advance Receipt</Link>
            }
          />

          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="basic-form">
                    <FormikProvider value={formik}>
                      <Form onSubmit={formik.handleSubmit}>
                        <Row>
                          <Col lg={4}>
                            <Field
                              label={"Order Booking No."}
                              name="OrderBookingNo"
                              placeholder={"Search here...."}
                              component={CustomInput}
                              maxLength={15}
                              required
                            />
                          </Col>
                          <Col lg={2}>
                            <div className="mb-3">
                              <Label>&nbsp;</Label>
                              <InputGroup>
                                <button
                                  type="button"
                                  className="btn mt-1 mr-2 btn-xs btn-primary"
                                  onClick={(e) => {
                                    getOrderDetailsByOrderBookingNo();
                                  }}
                                >
                                  Search
                                </button>
                              </InputGroup>
                            </div>
                          </Col>
                        </Row>

                        {AddOrderBookingID ? (
                          <Row>
                            <Col lg={3}>
                              <b>Patient No.</b> : &nbsp;&nbsp; {PatientNo}
                            </Col>
                            <Col lg={6}>
                              <b>Patient Name</b> : &nbsp;&nbsp; {PatientName}
                            </Col>
                            <Col lg={3} style={{ textAlign: "right" }}>
                              <button
                                className="btn mr-2 btn-xs btn-light"
                                onClick={() => {
                                  setOrderBookingID(AddOrderBookingID);
                                  setOrderDetailModal(true);
                                }}
                                // onClick={() => {
                                //   setOrderDetailModal(true);
                                // }}
                              >
                                View Order Detail
                              </button>
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}
                        <hr></hr>
                        <Row>
                          <Col lg={3}>
                            <Field
                              label={"Advance Given By Name"}
                              name="AdvanceGivenByName"
                              placeholder={"Enter Advance Given By Name"}
                              component={CustomInput}
                              onChange={(e) => {
                                setFieldValue(
                                  "AdvanceGivenByName",
                                  e.target.value.replace(/[^A-Za-z ]/g, "")
                                );
                              }}
                              required
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label={"Mobile No."}
                              name="MobileNo"
                              placeholder={"Enter Mobile No."}
                              country={country}
                              countryCode={CountryCode}
                              component={CustomPhoneInput}
                              onChange={(value, { countryCode, dialCode }) => {
                                setFieldValue("CountryCode", dialCode);
                                setFieldValue(
                                  "MobileNo",
                                  value.substring(dialCode.toString().length)
                                );
                              }}
                              required
                            />
                          </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                          <Col lg={3}>
                            <Field
                              label={"Advance Amount"}
                              name="AdvanceAmount"
                              placeholder={"Advance Amount"}
                              component={CustomInput}
                              type="number"
                              required
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label={"Advance Received Date"}
                              name="AdvanceReceivedDate"
                              placeholder={"Select Received Date"}
                              component={CustomFlatpickr}
                              options={{
                                maxDate: moment(new Date()).format(
                                  "YYYY-MM-DD"
                                ),
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                              }}
                              required
                            />
                          </Col>

                          <Col lg={4}>
                            <Field
                              label={"Mode of Payment"}
                              name="ModeofPayment"
                              placeholder={"Select Mode of Payment"}
                              component={CustomSelect}
                              options={modeOfPaymentOptions}
                              required
                              isClearable={false}
                            />
                          </Col>
                          <Col lg={10}>
                            <Field
                              label={"Advance Remark"}
                              name="AdvanceRemark"
                              placeholder={"Enter Advance Remark"}
                              component={CustomInput}
                              maxLength={200}
                            />
                          </Col>
                        </Row>
                        <hr></hr>
                        <button type="submit" className="btn mr-2 btn-primary">
                          Submit
                        </button>
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={(e) => {
                            history.goBack();
                          }}
                        >
                          Cancel
                        </button>
                      </Form>
                    </FormikProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            className="modal fade"
            show={orderDetailModal}
            onHide={setOrderDetailModal}
            size="xl"
          >
            <div className="modal-header">
              <h4 className="modal-title fs-20">Order Detail</h4>
              <button
                type="button"
                className="btn close"
                onClick={() => setOrderDetailModal(false)}
              >
                <span>×</span>
              </button>
            </div>

            <div className="modal-body">
              <ModalOrderBookingDetail
                orderBookingID={orderBookingID}
                setOrderDetailModal={setOrderDetailModal}
              ></ModalOrderBookingDetail>
            </div>
          </Modal>
        </Spin>
      </Fragment>
    </>
  );
};

export default AddOrderBookingAdvance;
